import cls from 'classnames'
import { useState } from 'react'

// import check from '../icons/check.svg?react'
import type { ChangeEvent, Input, Option } from '../types'

type Props = {
  checked?: boolean
  id: string
  input?: Input
  label: string
  onChange: (obj: ChangeEvent) => void
  options?: Option[]
}

const Item: React.FC<Props> = ({
  checked,
  id,
  input,
  label,
  onChange,
  options,
}) => {
  const [isChecked, setIsChecked] = useState(checked)

  const onClick = () => {
    setIsChecked(!isChecked)

    onChange({
      id,
      type: 'checkbox',
      checked: !isChecked,
    })
  }

  return (
    <div className="item">
      <div
        className={cls('item-label', { checked: isChecked })}
        onClick={onClick}
      >
        <span className="item-label-check">
          {/*<img src={check} alt="" />*/}
        </span>

        <span className="item-label-text">{label}</span>
      </div>

      <div className="item-body">
        {input && isChecked && (
          <input
            type="text"
            name={input.name}
            placeholder={input.placeholder}
            defaultValue={input.value}
            onChange={(e) => {
              const val = e.target.value

              onChange({
                id,
                type: 'input',
                value: val,
              })
            }}
          />
        )}

        {options && isChecked && (
          <>
            {options.map((option: Option) => (
              <Item key={option.id} onChange={onChange} {...option} />
            ))}
          </>
        )}
      </div>
    </div>
  )
}

export default Item
